import {z} from '@hono/zod-openapi';

export const VoiceDebugReadyResponseSchema = z
  .object({
    schemaVersion: z.literal('1.0.0'),
    state: z.enum(['active', 'failed']),
  })
  .strict()
  .openapi('VoiceDebugReadyResponseSchema');

export type VoiceDebugReadyResponse = z.infer<typeof VoiceDebugReadyResponseSchema>;
